/**
 * 全局 Toast 提示模块
 */

let toastStylesInstalled = false;

function ensureToastStyles() {
  if (toastStylesInstalled) return;
  if (typeof document === 'undefined' || !document.head) return;

  const styleId = 'ink-toast-styles';
  if (document.getElementById(styleId)) {
    toastStylesInstalled = true;
    return;
  }

  const toastStyles = document.createElement('style');
  toastStyles.id = styleId;
  toastStyles.textContent = `
    @keyframes toastIn {
      from { opacity: 0; transform: translateX(-50%) translateY(20px); }
      to { opacity: 1; transform: translateX(-50%) translateY(0); }
    }
    @keyframes toastOut {
      from { opacity: 1; transform: translateX(-50%) translateY(0); }
      to { opacity: 0; transform: translateX(-50%) translateY(-20px); }
    }
  `;

  document.head.appendChild(toastStyles);
  toastStylesInstalled = true;
}

export function showToast(message) {
  if (typeof document === 'undefined' || !document.body) return;

  ensureToastStyles();

  const existing = document.querySelector('.toast');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.className = 'toast';
  toast.textContent = message;
  toast.style.cssText = `
    position: fixed;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    background: var(--glass-bg);
    backdrop-filter: blur(20px);
    border: 1px solid var(--glass-border);
    padding: 12px 24px;
    border-radius: 12px;
    color: var(--ink-white);
    font-size: 0.875rem;
    z-index: 1000;
    animation: toastIn 0.3s ease-out;
  `;

  document.body.appendChild(toast);

  setTimeout(() => {
    toast.style.animation = 'toastOut 0.3s ease-out forwards';
    setTimeout(() => toast.remove(), 300);
  }, 2000);
}

export { ensureToastStyles };
